//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
export default {
    props: {
        verify_type: {
            type: String,
            default: ''
        },
        now: [String, Number]
    },
    data () {
        return {
            finish: false,
            zone: '',
            visit_times: '',
            questions: [],
            answer: {},
            question: '',
            items: [],
            alphabets: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
            need: false
        }
    },
    watch: {
        verify_type (v) {
            // this.verify()
        },
        now (v) {
            this.init()
            this.verify()
        }
    },
    mounted () {
        this.init()
        this.verify()
    },
    methods: {
        init () {
            this.questions = []
            this.finish = false
            this.answer = {}
            this.question = ''
            this.items = []
            this.zone = ''
            this.visit_times = ''
            this.need = false
        },
        handleQuestion (data, answer) {
            this.finish = data.finish
            const answeredQuestions = Object.keys(answer)
            if (answeredQuestions.length > this.questions.length) {
                const pastQuestion = answeredQuestions[answeredQuestions.length - 1]
                this.questions.push({
                    question: this.question,
                    items: this.items,
                    answer: answer[pastQuestion]
                })
            }
            if (!data.finish) {
                this.question = Object.keys(data.question)[0]
                this.items = data.question[this.question]
            } else {
                this.need = data.success
                this.zone = data.zone || []
                this.zone_ids = data.zone_ids || []
                this.visit_times = data.visit_times || ''
            }
        },
        verify () {
            const { verify_type } = this
            Service.verifyQualication(this.answer, verify_type).then(data => {
                this.handleQuestion(data, this.answer)
            })
        },
        onSelect (e) {
            const { item } = e.currentTarget.dataset
            const { question } = this
            this.answer[question] = item
            this.verify()
        },
        goNext (zone, visit_time) {
            this.$emit('next', this.zone.join('、'), this.visit_time, this.questions, this.need, this.zone_ids.join(','))
            this.init()
        },
        deleteItem (e) {
            const { index } = e.currentTarget.dataset
            const item = this.questions[index]
            this.question = item.question
            this.items = item.items
            this.questions = this.questions.splice(0, index)
            this.answer = this.questions.reduce((answer, item) => {
                answer[item.question] = item.answer
                return answer
            }, {})
            this.finish = false
        }
    }
}
